import { padEnd, parseInt } from 'lodash';
import { interpolator } from '@fiverr-private/futile';
import { currencyFormat } from '@fiverr-private/localization';

export const NUMBER_PARTS = {
    INTEGER: 'integer',
    FRACTION: 'fraction',
    DECIMAL: 'decimal',
};

const currencyObj = {
    symbol: '$',
    code: 'USD',
    name: 'USD',
    template: '{{amount}}',
};

export const fallbackFormatFraction = (numberArr = []) => {
    const integer = numberArr.find(({ type }) => type === NUMBER_PARTS.INTEGER);
    const fraction = numberArr.find(({ type }) => type === NUMBER_PARTS.FRACTION);
    return fraction && parseInt(fraction.value) > 0
        ? `${integer.value}<sup>${padEnd(fraction.value, 2, '0')}</sup>`
        : integer.value;
};

// TEMP - mocking the number array until the fromatting is rolled out
export const fallbackArray = (price) => {
    const [integer, fraction] = price.toString().split('.');
    const priceArr = [
        {
            type: NUMBER_PARTS.INTEGER,
            value: integer,
        },
    ];

    if (fraction) {
        priceArr.push({
            type: NUMBER_PARTS.FRACTION,
            value: fraction,
        });
    }
    return priceArr;
};

/**
 * Build the price string out of the price array we got back from currencyFormat with asParts:true
 * @param {Array.<{type: String, value: String}>} numberArr - the response from currencyFormat asParts:true
 * @returns {string} - string that represents the price that need to be displayed (with the currency)
 */
export const buildPriceStr = (numberArr = []) => {
    const formattedParts = numberArr.map(({ type, value }) => {
        switch (type) {
            case NUMBER_PARTS.FRACTION:
                return `<sup>${padEnd(value, 2, '0')}</sup>`;
            case NUMBER_PARTS.DECIMAL:
                return '';
            default:
                return value;
        }
    });
    return formattedParts.join('');
};

export const priceMarkupFormatter = (price) => {
    const { template } = currencyObj;
    const interpolate = interpolator(/{{([^{}]*)}}/g);
    const fallbackValue = fallbackArray(price);

    const numberArr = currencyFormat({
        value: price,
        currencyCode: currencyObj.name,
        options: {
            fallbackValue: fallbackArray(price),
            asParts: true,
        },
    });

    const safeNumberArr = Array.isArray(numberArr) ? numberArr : fallbackValue;

    if (JSON.stringify(fallbackValue) === JSON.stringify(safeNumberArr)) {
        return interpolate(template, { amount: fallbackFormatFraction(safeNumberArr) });
    }

    return buildPriceStr(safeNumberArr);
};
